import React from 'react';

export const HeaderWidget = ({
  title,
  subtitle,
  value,
  color,
  className,
  ...otherProps
}) => (
  <div
    className={`HeaderWidget ${color || ''} ${className || ''}`}
    {...otherProps}>
    <div className="leftBox">
      <span className="title">{title}</span>
      <span className="subtitle">{subtitle}</span>
    </div>
    <div className="count">{!!value ? value : '-'}</div>
  </div>
);

export const HeaderCountWidget = ({ count, ...otherProps }) => (
  <HeaderWidget value={count || '-'} {...otherProps} />
);

export const HeaderPercentWidget = ({ percent, ...otherProps }) => (
  <HeaderWidget value={!!percent ? `${percent}%` : '-'} {...otherProps} />
);

export default HeaderWidget;
